import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// S/ME's own house advert — a single small banner at the very bottom of the homepage.
// This is its ONLY placement on the whole site; member spaces are never filled with it.
export default function HouseAd() {
  return (
    <section className="bg-cream px-5 sm:px-8 py-8">
      <div className="max-w-[1280px] mx-auto">
        <Link to="/join" className="group flex items-center justify-between gap-4 border border-ink/15 bg-ink text-cream px-5 sm:px-8 py-5 grain relative overflow-hidden" data-testid="house-ad-strip">
          <div className="min-w-0 relative z-10">
            <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-gloss-gold mb-1">Advertisement · S/ME</p>
            <p className="font-serif text-lg sm:text-2xl tracking-tight leading-tight truncate">Everything your business needs to be seen. £30 a month.</p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-2 border border-cream/60 px-5 py-2.5 overline shrink-0 relative z-10 group-hover:bg-cream group-hover:text-ink transition-colors">
            Explore membership <ArrowUpRight size={13} />
          </span>
        </Link>
      </div>
    </section>
  );
}
